/*
 * App Actions
 *
 * Actions change things in your application
 * Since this boilerplate uses a uni-directional data flow, specifically redux,
 * we have these actions which are the only way your application interacts with
 * your application state. This guarantees that your state is up to date and nobody
 * messes it up weirdly somewhere.
 *
 * To add a new Action:
 * 1) Import your constant
 * 2) Add a function like this:
 *    export function yourAction(var) {
 *        return { type: YOUR_ACTION_CONSTANT, var: var }
 *    }
 */

import {
  APP_STARTUP,
  APP_CHANGE_FORM,
  APP_CHANGESTATE, APP_CHECK_TOKEN,
  APP_CLEAR_ERROR,
  APP_OAUTH_LOGIN_REQUEST,
  APP_LOGIN_REQUEST,
  APP_LOGOUT,
  APP_REGISTER_REQUEST,
  APP_REQUEST_ERROR,
  APP_SENDING_REQUEST,
  APP_SET_AUTH,
} from './constants';

export function loadStartup() {
  return {
    type: APP_STARTUP,
  };
}

export function changeAppState(appstate) {
  return {
    type: APP_CHANGESTATE,
    payload: appstate,
  };
}

export function checkToken() {
  return { type: APP_CHECK_TOKEN };
}

export function changeForm(newFormState) {
  return { type: APP_CHANGE_FORM, newFormState };
}

export function setAuthState(newAuthState) {
  return { type: APP_SET_AUTH, newAuthState };
}

export function sendingRequest(sending) {
  return { type: APP_SENDING_REQUEST, sending };
}

export function loginRequest(data) {
  return { type: APP_LOGIN_REQUEST, data };
}

export function registerRequest(data) {
  return {
    type: APP_REGISTER_REQUEST,
    payload: data,
  };
}

export function oAuthLoginRequest(service) {
  return {
    type: APP_OAUTH_LOGIN_REQUEST,
    payload: {
      service,
    },
  };
}

export function logout() {
  return { type: APP_LOGOUT };
}

export function requestError(error) {
  return { type: APP_REQUEST_ERROR, error };
}

export function clearError() {
  return { type: APP_CLEAR_ERROR };
}



// WEBPACK FOOTER //
// ./src/actions.js